import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OccupancyEnum, RackPositionEnum, RackPositionTypeEnum } from '@gtpl/shared-models/masters';
export class RackDTONew {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Id should not be empty" })
    rackMasterId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Position Code should not be empty" })
    rackPositionCode: string;

    @ApiProperty({
        enum: RackPositionEnum,
        default: RackPositionEnum.BACK_CENTER
    })
    @IsNotEmpty({ message: "Rack Position should not be empty" })
    @IsEnum(RackPositionEnum)
    rackPosition: RackPositionEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Level should not be empty" })
    @IsNumber()
    rackLevel: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Rack Column should not be empty" })
    @IsNumber()
    rackColumn: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Boundaries should not be empty" })
    rackBoundaries: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Associate RFIS's should not be empty" })
    assocRfId: string;

    @ApiProperty({
        enum: OccupancyEnum,
        default: OccupancyEnum.NOT_OCCUPIED
    })
    @IsOptional()
    @IsEnum(OccupancyEnum)
    occupancy: OccupancyEnum;
    @ApiProperty({
        enum: RackPositionTypeEnum,
        default: RackPositionTypeEnum.REAR
    })
    @IsOptional()
    @IsEnum(RackPositionTypeEnum)
    rackPositionType: RackPositionTypeEnum;

    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;

    @ApiProperty()
    zoneId:number;

}